//US currency formatting simpler/shorter but breaks when using large numbers
export const currencyExceptions = [
  "XBTUSD",
  "XETUSD",
  "XLCUSD",
  "XEOUSD",
  "XMRUSD",
  "XZCUSD",
  "XDHUSD",
];

export const usCurrency = (number: number, ticker?: any) => {
  if (
    !ticker ||
    !["SPOT", "CROSS"].includes(ticker.security_typ) ||
    currencyExceptions.includes(ticker.ticker)
  ) {
    return number.toLocaleString("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }
  return number.toLocaleString("en-US", {
    maximumFractionDigits: 4,
    minimumFractionDigits: 4,
  });
};

//US currency formatting more useful when using large numbers
export const usdCurrency = (value: number) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "USD",
  })
    .format(value)
    .replace("$", "");

//Format to make sure that number has no decimal places
export const noDecimals = (number: number | string) => {
  //checks that number is not a string otherwise .toLocalString() won't work
  if (typeof number !== "number") {
    if (number[0] === "$")
      return parseFloat(number.substring(1)).toLocaleString("en-US", {
        maximumFractionDigits: 0,
      });
    return parseFloat(number).toLocaleString("en-US", {
      maximumFractionDigits: 0,
    });
  }
  return number.toLocaleString("en-US", { maximumFractionDigits: 0 });
};

//Account for Daylight Savings
export const dayLightSaving = (d: Date | string | number) => {
  const date = new Date(d);
  const jan = new Date(date.getFullYear(), 0, 1).getTimezoneOffset();
  const jul = new Date(date.getFullYear(), 6, 1).getTimezoneOffset();
  return Math.max(jan, jul) !== date.getTimezoneOffset();
};

export const formatDate = (date: Date, shortForm?: boolean) =>
  shortForm
    ? new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        year: "2-digit",
        month: "numeric",
        day: "2-digit",
      }).format(date)
    : new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "2-digit",
      }).format(date);

export const stringToUrl = (str: string) => {
  return encodeURI(str.replace(/ /g, "-").toLowerCase());
};
